<template>
  <span class="d-sr-only"><slot></slot></span>
</template>
